import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  appMenu: { fontFamily: "Avenir" },
  light: {
    color: " #7b8489d1",
  },
  row: {
    padding: "0px",
    borderTop: "0px",
    position: "relative",
    border: "1px solid #e2e2e2",
    borderRadius: "0px",
    lineHeight: "1.45",
    margin: "0px 0",
  },
  floatRight: {
    float: 'right',
    marginTop: '19px'
  },
  settingsIcon: {
    fontSize: "1.4em",
    marginBottom: "-5px",
    marginRight: "7px",
  },
  settingsButton: {
    margin: "10px auto",
    width: "100%",
    border: "1px solid #39b7ff",
    color: "#39b7ff",
    borderRadius: "5px",
    padding: "8px 19px",
  },
  headerRow: {
    padding: "5px 20px 20px",
    borderBottomLeftRadius: "5px",
    borderBottomRightRadius: "5px",
    marginBottom: "5px",
    margin: "0 1px",
  },
  avatar: {
    color: "#42b3f4",
    fontSize: "1.4em",
    borderRadius: "50px",
    margin: "0px 5px 0px 2px",
  },
  requirements: {
    border: "1px solid #ebedfa",
    padding: "0px",
  },
  active: {
    padding: "0 0 20px",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
    marginBottom: "2px",
    fontWeight: "300",
    color: "#fff",
  },
  greeting: {
    fontWeight: "900",
    fontSize: "19px",
    padding: "0",
    margin: "0 0 -.6rem 0",
    letterSpacing: " .01em",
  },
  greetingSubText: {
    letterSpacing: ".01em",
    fontWeight: "300",
    fontSize: "19px",
  },
  welcomeContainer: {
    padding: "8px 0px 7px",
  },
  patientContainer: {
    padding: "27px 0 20px 10px",
    position: "relative",
  },
  reward: {
    position: "relative",
  },
  rewardBage: {
    color: "#0093ff63",
    fontSize: "90px",
  },
  rewardAmount: {
    fontWeight: "600",
    marginTop: "2px",
  },
  iconBadge: {
    margin: " 0 7px -4px 0px",
    fontSize: "1.2em",
  },
  confirmed: {
    color: "#02aaff",
    fontWeight: "600",
  },
  cprIcon: {
    width: "22px",
    color: "#eee",
    opacity: "0.5",
    marginRight: "5px",
  },
  statusMessage: {
    width: "fit-content",
    padding: "0px 4px",
  },
  pushRight: {
    float: "right",
  },
  completedBtnIcon: {
    padding: "1px 2px",
    borderRadius: "25px",
    marginTop: "-3px",
    color: "#1a237e",
    fontSize: "22px",
  },
  submit: {
    color: "#fff",
    float: "right",
    padding: "3px 15px",
    textDecoration: "none",
    margin: "5px 10px 0 0",
    borderRadius: "30px",
    background: "#29b6f6",
  },
  cancel: { color: " #fd1b5f", float: "right", textDecoration: "none", margin: "-5px 0px 10px 0" },
  cancelIcon: { fontSize: "1.5em", margin: " 0 5px -6px 0px" },
  completedCheck: { margin: "3px 4px -4px -3px", fontSize: "21px" },
  buttons: { display: "flex", padding: "10px" },
  status: { margin: "0 0 10px 0px" },
  formLabel: { margin: "0px", textTransform: "none" },
  completedFilled: {
    backgroundColor: "#1a237e",
    color: "#fff",
    textAlign: "center",
    borderRadius: "5px",
    padding: "7px 0px",
    "&:hover": {
      backgroundColor: " #283593",
    },
  },
  completed: {
    color: "#1a237e",
    textTransform: "uppercase",
    fontWeight: "600",
  },

  confirmFilled: {
    background: "#29b6f6",
    color: "#fff",
    borderRadius: "5px",
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "600",
    padding: "7px 0px",
    "&:hover": {
      backgroundColor: " #4fc3f7",
    },
  },

  redFilled: {
    background: "#f44336",
    color: "#fff",
    textTransform: "uppercase",
    fontWeight: "600",
    borderRadius: "5px",
    textAlign: "center",
    padding: "7px 0px",
    "&:hover": {
      color: "white",
      backgroundColor: "#ef5350",
    },
  },
  outline: {
    color: "#1a237e",
    textTransform: "uppercase",
    fontWeight: "600",
    textDecoration: "none",
    textAlign: "center",
    borderRadius: "5px",
    padding: "7px 0px",
    border: "1px solid #0012692e",
    background: "#fff",
    "&:hover": {
      border: "1px solid #465e6c",
      backgroundColor: "#7b848914",
      cursor: "pointer",
    },
  },
  inlineEdit: {
    background: "#1a237e",
    color: "#ffff",
    textTransform: "uppercase",
    fontWeight: "600",
    textDecoration: "none",
    textAlign: "center",
    fontSize: "19px",
    borderRadius: "5px",
    padding: "7px 0px",
    "&:hover": {
      color: "#ffff",
      background: "#283593",
      cursor: "pointer",
      textDecoration: "none",
    },
  },
  confirmationSubmit: {
    color: "#fff",
    padding: "9px 12px",
    textAlign: "center",
    margin: "10px 0",
    textDecoration: "none",
    borderRadius: "5px",
    background: "#2cb5fa",
    "&:hover": {
      textDecoration: "none",
      color: "white",
      opacity: "0.9",
    },
  },
  confirmationCancel: {
    textDecoration: "none",
    color: " #fff",
    textAlign: "center",
    padding: "9px 12px",
    borderRadius: "5px",
    background: "#fd1b5f",
    "&:hover": {
      textDecoration: "none",
      color: "white",
      opacity: "0.9",
    },
  },
  statusLink: {
    color: "#042655",
    textDecoration: "none",
    "&:hover": {
      color: "#337ab7",
    },
  },
  fadeOut: {
    position: "relative",
    marginBottom: "10px",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0",
      backgroundImage: "linear-gradient(rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 1) 100%)",
    },
  },
  document: {
    background: "#f7f8f9",
    padding: "5px 0px",
    borderRadius: "5px",
    fontSize: "6.5em",
    color: "#42b3f4",
    "&:hover": {
      color: "#337ab7",
    },
  },

  progress: {
    display: " flex",
    flexDirection: "column",
    padding: "0px 0px 0px",
    justifyContent: "center",
  },

  timeline: {
    borderRadius: "25px",
    width: "99.5%",
    margin: "auto",
    position: "relative",
    backgroundColor: "#eff4fa",
    height: "11px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: "0",
  },

  timeline__progress: {
    minWidth: "25%",
    zIndex: "1",
    borderRadius: "500px",
    position: "absolute",
    background: "linear-gradient(-220deg, #001477, #2cb5fa)",
    height: "11px",
    transition: "all 0.2s ease",
  },
  timeline__progress_completed: {
    minWidth: "25%",
    zIndex: "1",
    borderRadius: "500px",
    position: "absolute",
    background: "linear-gradient(-220deg, #001477, #2cb5fa)",
    height: "11px",
    transition: "all 0.2s ease",
  },
  timeline__progress_past_due: {
    zIndex: "1",
    borderRadius: "500px",
    position: "absolute",
    background: "linear-gradient(-220deg, #001477, #f44336)",
    height: "11px",
    transition: "all 0.2s ease",
  },

  pastDue: { color: "#f44336", fontWeight: "600" },
  pastDueIcon: {
    margin: " 0 5px -6px 0px",
    fontSize: "1.5em",
  },

  id: {
    minWidth: "600px",
    fontWeight: "400",
  },
  requirement: { color: "#2494ff" },
  provider: { width: "200px" },
  name: { fontWeight: "700", width: "250px", fontSize: "18px" },
  label: {
    color: "#607d8b",
    fontSize: "19px",
    fontWeight: "400",
  },
  badge: {
    width: "10px",
    verticalAlign: "top",
  },

  date: {
    verticalAlign: "top",
    width: "220px",
  },
  view: { marginTop: "10px", textAlign: "right", color: "#2494ff" },
  requirementListItem: { border: "1px solid #ebebeb", padding: "20px", borderRadius: "8px" },
  requirementItem: {
    border: "0px solid #e2e2e2",
    padding: "0px",
    borderRadius: "5px",
    margin: "20px 0",
  },
  details: {
    borderTop: "1px solid #ebebeb",
    marginTop: "10px",
    marginBottom: "20px",
    padding: " 20px 5px 20px",
  },
  cancelIconBtn: {
    margin: "0px 5px -4px 0px",
    fontSize: "1.1em",
  },
  labelIcon: {
    border: "1px dotted #42b3f49e",
    width: "22px",
    height: "22px",
    margin: "0px 5px 0px 2px",
    color: "#2cb5fa",
    padding: "2px",
    borderRadius: "100%",
  },
  xIcon: { color: "#f44336", margin: "0 -2px 0px 2px", fontSize: "1.2em" },
  checkIcon: {
    color: "#2cb5fa",
    margin: "0 0px 2px 2px",
    fontSize: "1.2em",
  },
  formLabel: { margin: "0px", textTransform: "none" },
  datepicker: {
    fontSize: "19px",
    padding: "20px",
  },
  formTitle: {
    color: "#1a237e",
    margin: "8px 0px 8px 0px",
    fontWeight: "700",
    fontSize: "19px",
  },
  formLink: {
    color: ":#1a237e",
    margin: "25px 0 0",
    "&:hover": {
      color: "#337ab7",
    },
  },
  formLinkIcon: {
    fontSize: "1em",
    margin: " 0 0px -3px 5px",
  },
  mt20: {
    marginTop: "20px",
  },
  mb20: {
    marginBottom: "20px",
  },
  alignR: { textAlign: "right" },
  iconBtn: { margin: "0 0px -8px", fontSize: "1.4em" },
  textarea: {},
  statusBar: {
    padding: "20px 0",
  },

  menuBtnBadge: {
    fontSize: "1.4em",
    marginLeft: "-3px",
    padding: "5px",
    borderRadius: "100%",
    marginRight: "5px",
    "&:hover": {
      background: " #f0f8ff47",
    },
  },
  menuBtn: {
    fontSize: "1.4em",
    marginLeft: "-3px",
    padding: "5px",
    borderRadius: "100%",
    marginRight: "2px",
    "&:hover": {
      background: " #f0f8ff47",
    },
  },
  activeMenuLink: {
    margin: "0 2px -19px 0px",
    fontSize: "19px",
    padding: "10px 10px 5px",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    background: " #f0f8ff47",
  },
  menuLink: {
    margin: "0 2px -19px 0px",
    padding: "10px 10px 5px",
    fontSize: "19px",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    "&:hover": {
      background: " #f0f8ff47",
    },
  },
  scrollBtn: {
    background: "#2cb5fa",
    borderRadius: "100%",
    padding: "13.5px",
    color: "#fff",
    height: "48px",
    width: "48px",
    boxShadow:
      " 0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 12px 17px 2px rgb(0 0 0 / 14%), 0px 5px 22px 4px rgb(0 0 0 / 12%)",
  },
  scrollBtnIcon: { fontSize: "21px" },
  chatIcon: {
    margin: "10px 3px -4px 0",
  },
  messages: {
    padding: "20px 0px 20px",
  },
  messageForm: {
    padding: "20px 0px",
  },
  formPaper: {
    background: "#ebf6ff",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
    padding: "30px 20px",
    marginTop: "10px",
    marginBottom: "-20px",
  },
  sendMessageBtn: {
    color: "#fff",
    background: "#2cb5fa",
    textAlign: "center",
    borderRadius: "5px",
    "&:hover": {
      opacity: "90%",
    },
  },
  sendIcon: {
    margin: "0 5px -3px",
    fontSize: "1.2em",
  },
  disabledBtn: {
    opacity: "80%",
    backgroundColor: " #9fb8c77d",
    color: "grey",
    textTransform: "uppercase",
    fontWeight: "600",
    borderRadius: "5px",
    boxShadow: "none",
  },
  error: {
    color: "#ff0040",
    margin: "8px 0px",
    maxWidth: "320px",
    fontWeight: "500",
    fontSize: "19px",
    background: "#ffd4e2",
    padding: "4px 8px",
    border: "1px solid #f7c1d2",
    borderRadius: "5px",
  },

  success: {
    margin: "10px 0px",
    color: " #179d1a",
    fontSize: "19px",
    fontWeight: "500",
    background: "#3eff414a",
    padding: "7px 10px",
    borderRadius: "5px",
  },
  successIcon: {
    fontSize: "1.4em",
    marginRight: "5px",
    marginBottom: "-4px",
  },
  responded: {
    background: "#d1dadc2e",
    borderBottom: "1px solid #efefef",
  },
  respondedIcon: { fontSize: "1.4em", marginBottom: "-5px" },
  listItem: {
    whiteSpace: "nowrap",
    color: "#1a237e",
    marginLeft: "8px",
    fontSize: "19px",
    overflow: "hidden",
  },
  notifications: {
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
  },

  templateTitle: {
    color: "#02aaff",
    fontWeight: "600",
    fontSize: "25px",
    margin: "1.5rem 0 .5rem",
  },
  header: { fontSize: "19px" },
  question: { fontWeight: "600", fontSize: "21px", color: "#1a247e" },

  disabledForm: { color: "#7b8489", marginBottom: "-3px" },
  enabledForm: {
    color: "#02aaff",
    fontSize: "1.4em",
    marginBottom: "-5px",
    marginLeft: "-10px",
  },
  activeListItem: { background: "#b7dfff" },
  newForm: {
    margin: "-10px 20px 25px 10px",
    padding: "10px 20px 0",
    borderRadius: "20px",
    background: "#c2e1ff8a",
  },
  oldForm: {
    padding: "25px",
    borderRadius: "5px",
    background: "#d1dadc2e",
    color: "#7b8489",
    border: "1px solid #ebebeb",
  },
  submitResponse: {
    color: "#fff",
    margin: "10px 0",
    padding: "0",
    textAlign: "center",
    textDecoration: "none",
    borderRadius: "5px",
    background: "#2cb5fa",
    "&:hover": {
      textDecoration: "none",
      color: "white",
      opacity: "0.9",
    },
  },
  submitContainer: {
    padding: "24px 8px",
  },
  inboxHeader: {
    fontSize: "19px",
    padding: "20px 20px 10px",
    fontFamily: "Avenir",
    color: "#042655",
    fontWeight: "800",
  },
  notificationsIcon: {
    fontSize: "1.5em",
    marginBottom: "-7px",
  },
  infoLabel: {
    fontSize: " 16px",
    fontWeight: "500",
    color: "#7b8489",
  },
  dateThin: {
    color: "#042655",
    fontWeight: "400",
  },
  headerLabel: {
    fontSize: "19px",
    textTransform: "uppercase",
    margin: "15px 0 0",
  },
  listPanel: {
    overflowY: "hidden",
    overflowX: "hidden",
  },
  buttonBox: {
    borderRadius: "5px",
    margin: "0px 10px 0px 10px",
    padding: "5px 6px",
    color: "#02aaff",
    border: "1px solid #ebebeb",
    "&:hover": {
      background: "#2cb5fa",
      color: "#ffff",
    },
  },

  controls: {
    position: "absolute",
    top: "calc(50% - 20px)",
  },

  buttonBoxDisabled: {
    background: "#fafafa",
    borderRadius: "5px",
    margin: "0px 10px 0px 10px",
    padding: "5px 6px",
    color: "#7b84896b",
    border: "1px solid #ebebeb",
  },
  chevronBtnIcon: {
    fontSize: "25px",
  },
  paper: {
    background: "#fff",
    padding: "8px 16px 24px",
    marginTop: "16px",
    boxShadow:
      "rgb(0 0 0 / 20%) 0px 1px 1px -1px, rgb(0 0 0 / 8%) 0px 1px 1px 0px, rgb(0 0 0 / 5%) 2px 0px 1px 0px",
    zIndex: "100000",
  },
  dateIcon: {
    fontSize: "1.2em",
    marginBottom: "-3px",
    color: "#042655",
    marginLeft: "5px",
    marginRight: "10px",
  },
  completedCheckIcon: {
    fontSize: "1em",
    marginBottom: "-2px",
    marginLeft: "5px",
    marginRight: "10px",
  },
  completedCheckBadge: {
    fontSize: "1.2em",
    marginBottom: "-5px",
    color: "#042655",
    marginLeft: "5px",
    marginRight: "10px",
  },
  field: { border: "1px solid #b0c2dd", borderRadius: "5px" },
  closeAlertIcon: {
    fontSize: "21px",
    padding: "4px 8px",
    "&:hover": {
      opacity: "0.75",
    },
  },
  completedStar: {
    background: "#42b3f4",
    fontSize: "1em",
    borderRadius: "50px",
    padding: "2px 4px 3px",
    margin: "0 5px -4px 5px",
    color: "#ffff",
  },
  markCompletedText: {
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 7%), 0px 1px 1px 0px rgb(0 0 0 / 0%), 0px 1px 3px 0px rgb(0 0 0 / 2%)",
    transition:
      "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    padding: "8px 16px",
    color: "#042655",
    fontSize: "19px",
    fontWeight: "500",
    borderRadius: "5px",
    position: "absolute",
    background: "#9dfbd3",
  },

  btnIcon: {
    height: "38px",
    width: "38px",
    marginRight: "2px",
    marginBottom: "-11px",
    padding: "5px",
  },
  cancelBtnIconSmall: {
    color: "#f44336",
    fontSize: "1.2em",
    margin: "7px",
    "&:hover": {
      color: "#d61e61",
    },
  },
}));
